import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from '../../../components/Select/index';
import 'parsleyjs';
import MaskedInput from 'react-text-mask';

class TrustForm extends Component {
    handleInputChange = event => {
        let { trustData, updateTrustData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;
            let tmpSelected = _.extend({}, trustData);
            tmpSelected[name] = value;
            updateTrustData(tmpSelected);
        }
    };

    handleMaskedInputChange = event => {
        let { trustData, updateTrustData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.value === ''
                    ? target.value
                    : parseInt(target.value.replace(/[-]/g, ''), 10);
            const name = target.name;
            let tmpSelected = _.extend({}, trustData);
            tmpSelected[name] = value;
            updateTrustData(tmpSelected);
        }
    };

    handleSelectChange = (name, value) => {
        let { trustData, updateTrustData } = this.props;
        let tmpSelected = _.extend({}, trustData);
        if (value !== null) {
            tmpSelected[name] = value[name];
        } else {
            tmpSelected[name] = '';
        }
        updateTrustData(tmpSelected);
    };

    handleStateSelectChange = (name, value) => {
        let { trustData, updateTrustData } = this.props;
        let tmpSelected = _.extend({}, trustData);
        if (value !== null) {
            tmpSelected[name] = value['code'];
        } else {
            tmpSelected[name] = '';
        }
        updateTrustData(tmpSelected);
    };

    render() {
        let {
            trustData,
            countryList,
            stateList,
            clientList,
            isEditable,
            roleName,
            formRef
        } = this.props;
        return (
            <form ref={formRef}>
                {clientList && (
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>*Client</label>
                            <Select
                                clearable={false}
                                labelKey="name"
                                valueKey="clientId"
                                name="clientId"
                                selectedValue={trustData.clientId}
                                onChange={this.handleSelectChange}
                                options={clientList}
                                disabled={
                                    !isEditable || roleName !== 'Administrator'
                                }
                                required={true}
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Edgar Cik</label>
                        <input
                            className="form-control"
                            type="text"
                            name="edgarCik"
                            value={trustData.edgarCik}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>*Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={trustData.name}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-required
                            data-parsley-maxlength="200"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Formerly Known As Names</label>
                        <input
                            className="form-control"
                            type="text"
                            name="formerlyKnownAsNames"
                            value={trustData.formerlyKnownAsNames}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="4000"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Address-1</label>
                        <input
                            className="form-control"
                            type="text"
                            name="address1"
                            value={trustData.address1}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="100"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Address-2</label>
                        <input
                            className="form-control"
                            type="text"
                            name="address2"
                            value={trustData.address2}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="100"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Country</label>
                        <Select
                            name="countryId"
                            labelKey="name"
                            valueKey="countryId"
                            options={countryList}
                            selectedValue={trustData.countryId || 233}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>City</label>
                        <input
                            className="form-control"
                            type="text"
                            name="city"
                            value={trustData.city}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="100"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>State</label>
                        <Select
                            name="state"
                            labelKey="name"
                            valueKey="code"
                            options={stateList}
                            selectedValue={trustData.state}
                            onChange={this.handleStateSelectChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="2"
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Zip Code</label>
                        <input
                            className="form-control"
                            type="text"
                            name="postalCode"
                            value={trustData.postalCode}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Client Code</label>
                        <input
                            className="form-control"
                            type="text"
                            name="clientCode"
                            value={trustData.clientCode}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Fund Group Code</label>
                        <input
                            className="form-control"
                            type="text"
                            name="fundGroupCode"
                            value={trustData.fundGroupCode}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Sec 33 Act File Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="sec33ActFileNumber"
                            value={trustData.sec33ActFileNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Sec 40 Act File Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="sec40ActFileNumber"
                            value={trustData.sec40ActFileNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Federal ID</label>
                        <MaskedInput
                            id="trustFederalId"
                            mask={[
                                /\d/,
                                /\d/,
                                '-',
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/
                            ]}
                            className="form-control"
                            type="text"
                            name="federalId"
                            value={
                                trustData.federalId === 0
                                    ? ''
                                    : trustData.federalId
                            }
                            onChange={this.handleMaskedInputChange}
                            disabled={!isEditable}
                        />
                        {/*Following hidden input is added for parsley validation*/}
                        <input
                            type="text"
                            style={{ display: 'none' }}
                            value={
                                trustData.federalId === 0
                                    ? ''
                                    : trustData.federalId
                            }
                            readOnly
                            data-parsley-length="[9,9]"
                            data-parsley-error-message="This value length is invalid. It should be 9 characters long."
                            data-parsley-class-handler={'#trustFederalId'}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

TrustForm.propTypes = {
    trustData: PropTypes.object.isRequired,
    clientList: PropTypes.array,
    countryList: PropTypes.array.isRequired,
    stateList: PropTypes.array.isRequired,
    updateTrustData: PropTypes.func,
    isEditable: PropTypes.func.bool,
    roleName: PropTypes.func.string
};

TrustForm.defaultProps = {
    isEditable: true
};

export default TrustForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/TrustForm.js